/**
 * Lighting Component
 *
 * Scene-wide three-point lighting for the sculptures. Reads live
 * intensities from <LightingProvider> so the floating LightingPanel
 * can dial the look in real time. Designers tweak with sliders;
 * production picks up the persisted values from localStorage.
 */

import { useLighting } from '@/context/LightingContext'

export function Lighting() {
  const { settings } = useLighting()
  return (
    <>
      <ambientLight intensity={settings.ambient} />
      <directionalLight position={[5, 5, 5]} intensity={settings.key} castShadow />
      <directionalLight position={[-3, 3, -3]} intensity={settings.fill} />
      <directionalLight position={[0, 2, -5]} intensity={settings.rim} />
      <hemisphereLight color="#F1ECE6" groundColor="#3A332C" intensity={settings.hemisphere} />
    </>
  )
}
